import { IReview } from "../_types"
import { request } from "./http-client"
import { TParams } from "./types"

const reviewService = {
  getList: (params: TParams) =>
    request.get<{ reviews: IReview[]; count: string }>("/v1/user_reviews", {
      params,
    }),
  create: (params: TParams) => request.post("/v1/user_reviews", params),
  free: (params: TParams) => request.post("/v1/user_reviews/free", params),
}

export default reviewService
